/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import { Button } from "@/components/ui/button";
import { Table } from "@tanstack/react-table";
import { X } from "lucide-react";

import { Label } from "components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { useFilterActions } from "../ducks/hooks/action";
import { useFilterState } from "../ducks/hooks/state";
import SelectFilters from "./select-filters";
import { ModernCard } from "./modern-card";
import {
  TAX_OPTIONS,
  UF_OPTIONS_ENGINE_FILTER,
} from "../../exception-tax/utils/utils";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar<TData>({}: DataTableToolbarProps<TData>) {
  const { updateFilter, clearFilters } = useFilterActions();
  const filterState = useFilterState();

  return (
    <>
      <ModernCard title="Filtros de Pesquisa" description="" className="w-full">
        <div className="flex flex-col gap-6 mb-5">
          <div className="flex flex-wrap items-end gap-6">
            <SelectFilters />
          </div>

          <div className="flex flex-wrap items-end gap-6">
            <div className="flex flex-col w-56">
              <Label
                htmlFor="state-filter"
                className="text-sm font-semibold text-gray-700 mb-1"
              >
                Filtrar por Estado
              </Label>
              <Select
                value={filterState.filters.state || "all"}
                onValueChange={(value) => {
                  updateFilter("state", value === "all" ? undefined : value);
                }}
              >
                <SelectTrigger className="px-4 py-2 border rounded-xl text-gray-700 shadow-sm">
                  <SelectValue placeholder="Selecione um Estado" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Todos</SelectItem>
                  {UF_OPTIONS_ENGINE_FILTER.map((state) => (
                    <SelectItem key={state} value={state}>
                      {state}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="flex flex-col w-56">
              <Label
                htmlFor="exception-type-filter"
                className="text-sm font-semibold text-gray-700 mb-1"
              >
                Filtrar por Tributo
              </Label>
              <Select
                value={filterState.filters.tip || "all"}
                onValueChange={(value) => {
                  updateFilter("tip", value === "all" ? undefined : value);
                }}
              >
                <SelectTrigger className="px-4 py-2 border rounded-xl text-gray-700 shadow-sm">
                  <SelectValue placeholder="Selecione um Tributo" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Todos</SelectItem>
                  {TAX_OPTIONS.map((type) => (
                    <SelectItem key={type.value} value={type.value}>
                      {type.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>

        <div className="border-t-2 border-gray-200">
          {Object.keys(filterState.filters).some(
            (k) => filterState.filters[k as keyof typeof filterState.filters]
          ) && (
            <Button
              variant="default"
              onClick={clearFilters}
              className="h-10 mt-5 px-4 py-2 border rounded-xl shadow-sm border-transparent bg-transparent hover:bg-[#F5CB2B]"
            >
              <X className="w-5 h-5 text-gray-700" />
              <span className="text-gray-700 font-semibold text-sm">
                Resetar Filtros
              </span>
            </Button>
          )}
        </div>
      </ModernCard>
    </>
  );
}
